module.exports = __webpack_public_path__ + "media/tts_g1_e.aa50ae76.mp3";